import { create } from 'zustand';

export const useConnectionStore = create((set) => ({
  // vMix
  vmixConnected: false,
  vmixInputs: [],
  vmixTally: { program: [], preview: [] },
  // Workspace vMix instances a cue action can target (Primary is implicit)
  vmixInstances: [],

  // Singular. `singularConfigured` = a token is stored server-side; it cannot be
  // read off the show row because the key is redacted from REST and excluded
  // from sync, so it comes from GET /api/singular/status instead.
  singularConfigured: false,
  singularConnected: false,
  singularCompositions: [],

  // WebSocket
  wsConnected: false,
  wsReconnecting: false,

  // Actions
  setVmixStatus: (connected, inputs = []) => set({
    vmixConnected: connected,
    vmixInputs: inputs,
  }),

  setVmixTally: (tally) => set({ vmixTally: tally }),

  setVmixInstances: (instances) => set({ vmixInstances: instances || [] }),

  setSingularConnected: (connected) => set({ singularConnected: connected }),

  setSingularStatus: ({ configured, connected }) => set({
    singularConfigured: !!configured,
    singularConnected: !!connected,
  }),

  setSingularCompositions: (compositions) => set({ singularCompositions: compositions }),

  setWsStatus: (connected, reconnecting = false) => set({
    wsConnected: connected,
    wsReconnecting: reconnecting,
  }),

  resetConnections: () => set({
    vmixConnected: false,
    vmixInputs: [],
    vmixTally: { program: [], preview: [] },
    vmixInstances: [],
    singularConfigured: false,
    singularConnected: false,
    singularCompositions: [],
    wsConnected: false,
    wsReconnecting: false,
  }),
}));
